import type { AnimationItem } from 'lottie-web';

import { AnimationKeyFrames } from '../../../Resume/EditResume/FileUpload/utils';

import { AnimationState } from './avatarUploadUtils';

export const runAvatarAnimationLifecycle = ({
  isSuccess,
  animationState,
  setAnimationState,
  animationInstance,
}: {
  isSuccess: boolean; // aka should show success message
  animationState: AnimationState | null;
  setAnimationState: (state: AnimationState | null) => void;
  animationInstance: {
    current: AnimationItem | null;
  };
}) => {
  // Handle success
  if (isSuccess && animationState !== AnimationState.SUCCESS) {
    setAnimationState(AnimationState.SUCCESS);

    if (animationInstance.current) {
      animationInstance.current.addEventListener('loopComplete', (event) => {
        if (animationInstance.current) {
          animationInstance.current.removeEventListener('loopComplete');

          const isFirstLoopComplete = event.currentLoop === 1;
          const isSuccessAnimationSegment =
            animationInstance.current.totalFrames ===
            AnimationKeyFrames.END - AnimationKeyFrames.SUCCESS;

          if (isFirstLoopComplete && isSuccessAnimationSegment) {
            animationInstance.current.goToAndStop(AnimationKeyFrames.END, true);
          }
        }
      });
    }
  }
};
